<template>
	<div class="layout">
		<div class="header container">
			<div class="select">
				{{sectionTitle}}

				<template v-if="!basic">
					<div class="icon" v-html="require('@/assets/icons/sort-down-solid.svg')"/>

					<select :value="name" @change="selectSection">
						<option disabled selected>Vælg produkt</option>
						<option v-for="section in allSections" :key="section.name" v-text="section.name"/>
					</select>
				</template>
			</div>

			<template v-if="!basic && !selector">
				<a class="remove" @click="remove" title="Slet linje" v-html="require('@/assets/icons/trash-solid.svg')"/>

				<a class="clone" :class="{disabled: !noErrors}" @click="clone" title="Dupliker linje" v-html="require('@/assets/icons/clone-solid.svg')"/>

				<a class="toggle" @click="toggleActive">
					<div class="icon" v-html="require('@/assets/icons/minus-light.svg')" v-if="active"/>
					<div class="icon" v-html="require('@/assets/icons/plus-light.svg')" v-else/>
				</a>
			</template>
		</div>

		<!-- has to be v-show so we can find elements with attribute data-error on submit -->
		<div class="main container" v-show="active || basic">
			<div class="content">
				<div class="required">* obligatorisk</div>
				<div class="fields"><slot name="fields"/></div>
			</div>
			<div class="header bottom">
				<template v-if="!basic && !selector">
					<a class="remove" @click="remove" title="Slet linje" v-html="require('@/assets/icons/trash-solid.svg')"/>

					<a class="clone" :class="{disabled: !noErrors}" @click="clone" title="Dupliker linje" v-html="require('@/assets/icons/clone-solid.svg')"/>

					<a class="toggle" @click="toggleActive">
						<div class="icon" v-html="require('@/assets/icons/minus-light.svg')" v-if="active"/>
						<div class="icon" v-html="require('@/assets/icons/plus-light.svg')" v-else/>
					</a>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		id: {type: String, required: false},
		name: {type: String, required: true},
		title: {type: String, required: true},
		active: {type: Boolean, required: true},
		selector: {type: Boolean, required: false}
	},
	computed: {
		basic: (t) => t.name === "Generelt",
		sectionTitle: (t) => t.basic ? t.name : t.title,
		allSections: (t) => t.$store.getters["order/allSections"],
		noErrors: (t) => t.$store.getters["order/noErrors"]
	},
	methods: {
		toggleActive() {
			this.$emit("update:active", !this.active);
		},
		remove() {
			this.$store.commit("order/removeSection", {id: this.id});
		},
		clone() {
			this.$emit("update:active", false);
			this.$store.commit("order/cloneSection", {name: this.name, id: this.id});
			const allSections = document.querySelectorAll(".layout");
			const last = allSections[allSections.length-1];
			const offset = 62+28;
			window.scrollTo(0, last.offsetTop-offset);
		},
		selectSection({target: {value}}) {
			this.$store.commit("order/addSection", {name: value});
			this.$emit("select");
			this.remove();
		}
	}
};
</script>

<style lang="scss" scoped>
.layout {
	background-color: $white1;
	border: 1px solid #979797;
	margin-bottom: 28px;

	.container {
		padding: 34px 78px;
		@include res(tablet) {
			padding: 34px 39px;
		}
		@include res(mobile) {
			padding: 34px 30px;
		}
	}

	.header {
		user-select: none;
		color: #3F6797;
		font-size: 18px;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.select {
			position: relative;
			display: flex;
			align-items: center;

			.icon {
				display: block;
				margin-left: 5px;
				margin-top: -5px;

				/deep/ svg {
					$s: 16px;
					width: $s;
					height: $s;

					path {
						fill: #5C5C5C;
					}
				}
			}

			select {
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				right: 0;
				opacity: 0;
				width: 100%;
				height: 100%;
			}
		}

		.remove {
			display: inline-flex;
			margin-left: auto;
			margin-right: 20px;

			/deep/ svg {
				$s: 15px;
				width: $s;
				height: $s;

				path {
					fill: #4A4A4A;
				}
			}
		}

		.clone {
			display: inline-flex;
			margin-right: 20px;

			/deep/ svg {
				$s: 15px;
				width: $s;
				height: $s;

				path {
					fill: #4A4A4A;
				}
			}

			&.disabled {
				pointer-events: none;

				/deep/ svg path {
					fill: #E1E0E4;
				}
			}
		}

		.toggle {
			display: inline-flex;

			.icon {
				display: inline-flex;

				/deep/ svg {
					$s: 15px;
					width: $s;
					height: $s;

					path {
						fill: #4A4A4A;
					}
				}
			}
		}
	}

	.main {
		border-top: 1px solid #F5F5F5;

		.content {
			position: relative;

			.required {
				position: absolute;
				top: -25px;
				right: 0;
				font-size: 12px;
				font-weight: 300;
				font-style: italic;
				color: #4A4A4A;
				text-align: right;
			}

			.fields {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.field {

					.title{
						font-weight: 200px;
					}

				}
			}
		}

		.bottom {
			border-top: 1px solid #F5F5F5;
			padding-top: 32px;
			margin-bottom: 16px;
		}
	}
}
</style>
